import React from "react";
import {
    BrowserRouter,
    Routes as Switch,
    Route,
    Navigate,
} from "react-router-dom";
import Login from "./login";
import Contacts from "./contacts";
import UserWizard from "./user-wizard";
import ProfileSharing from "./profile-sharing";
import AcceptSharedContact from "./accept-shared-contact";
import Purchase from "./purchase";
import ValidateCheckout from "./validate-checkout";
import { RootState } from "../redux/root-store";
import { connect } from "react-redux";
import Profile from "./profile";
import ProtectedRoute from "./protectedRoute";
import Settings from "./settings";

const mapStateToProps = (state: RootState) => ({
    user: state.session.user,
});

interface AuthRouteProps extends ReturnType<typeof mapStateToProps> {
    children: React.ReactElement;
}

const _AuthRoute = (props: AuthRouteProps) => {
    const { user } = props;
    if (user !== null) {
        return (
            <Navigate
                to={user._protectedRouteRedirect || "/contacts"}
                replace={false}
            />
        );
    }
    return props.children;
};
const AuthRoute = connect(mapStateToProps)(_AuthRoute);

const RoutesIndex: React.FC = () => {
    return (
        <BrowserRouter>
            <Switch>
                <Route
                    path={"/login"}
                    element={
                        <AuthRoute>
                            <Login />
                        </AuthRoute>
                    }
                />
                <Route
                    path={"/contacts"}
                    element={
                        <ProtectedRoute>
                            <Contacts />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={"/profile-sharing"}
                    element={
                        <ProtectedRoute>
                            <ProfileSharing />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={"/share"}
                    element={
                        <ProtectedRoute>
                            <AcceptSharedContact />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={"/purchase"}
                    element={
                        <ProtectedRoute>
                            <Purchase />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={"/validate-purchase"}
                    element={
                        <>
                            <ValidateCheckout />
                        </>
                    }
                />
                <Route
                    path={"/user-wizard"}
                    element={
                        <ProtectedRoute>
                            <UserWizard />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={"/profile"}
                    element={
                        <ProtectedRoute>
                            <Profile />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={"/settings"}
                    element={
                        <ProtectedRoute>
                            <Settings />
                        </ProtectedRoute>
                    }
                />
                <Route path={"/"} element={<Navigate to="/login" />} />
            </Switch>
        </BrowserRouter>
    );
};

export default RoutesIndex;
